import axiosInstance from '../helpers/axios';
import { getToken } from './auth';

// Get event
export const getEvents = async (idBias) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/event/?bias=${idBias}&ordering=-created_at`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get event's info
export const getEventInfo = async (idEvent) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/event/${idEvent}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register event
export const registerEvent = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/event/create/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update event
export const updateEvent = async (idEvent, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/event/update/${idEvent}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Delete event
export const deleteEvent = async (idEvent, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/bias/event/${idEvent}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};
